var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-phone"},[_c('i',{staticClass:"el-icon-circle-check"}),_c('p',{staticClass:"txt"},[_vm._v("修改成功")]),_c('div',{staticClass:"btn go-back",on:{"click":function($event){return _vm.$router.push({ name: 'AccountSettings' })}}},[_vm._v(" 返回 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }